import { useTranslation } from 'react-i18next'
import { NS } from '~/enums'

export const useAssetTranslations = () => {
  const { t } = useTranslation()

  const programLabel = t('program', { ns: NS.CHALLENGES })
  const typeLabel = t('type_header', { ns: NS.ORDERS_PAYMENTS })
  const evaluationTypeLabel = t('evaluation_type', { ns: NS.CHALLENGES })
  const balanceLabel = t('balance', { ns: NS.CHALLENGES })
  const platformLabel = t('platform', { ns: NS.CHALLENGES })
  const platformsLabel = t('platforms', { ns: NS.CHALLENGES })
  const dailyDrawdownLabel = t('daily_drawdown', { ns: NS.CHALLENGES })
  const profitTargetLabel = t('profit_target', { ns: NS.CHALLENGES })
  const minimumTradingDaysLabel = t('minimum_trading_days', { ns: NS.CHALLENGES })
  const maximumDrawdownLabel = t('maximum_drawdown', { ns: NS.CHALLENGES })
  const profitShareLabel = t('profit_share', { ns: NS.CHALLENGES })
  const phase_1 = t('phase_1', { ns: NS.CHALLENGES })
  const phase_2 = t('phase_2', { ns: NS.CHALLENGES })
  const perc1_up_to_perc2 = t('perc1_up_to_perc2', { ns: NS.CHALLENGES })
  const dailyPause = t('daily_pause', { ns: NS.CHALLENGES })
  return {
    perc1_up_to_perc2,
    dailyDrawdownLabel,
    profitShareLabel,
    minimumTradingDaysLabel,
    profitTargetLabel,
    phase_1,
    phase_2,
    programLabel,
    typeLabel,
    evaluationTypeLabel,
    balanceLabel,
    platformLabel,
    platformsLabel,
    maximumDrawdownLabel,
    dailyPause,
  }
}
